module.exports = __webpack_public_path__ + "static/4-fd92b97203308f1dfd683d18eebeedbb.png";